module.exports = __webpack_public_path__ + "static/media/PC4.d423eacf.png";